import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    setAssociateInstallation,
    setAssoInstaPiechart,
} from "../../../../../store/slices/salesFinanceSlice";
import { fetchSalesTaxes } from "../../../../../store/slices/salesTaxesSlice";
import { fetchQuotations } from "../../../../../store/slices/hourlyRates";
import { fetchOtherExpenses } from "../../../../../store/slices/otherexpenses";
import { fetchEmployees } from "../../../../../store/slices/employeeAdminSlice";
import { fetchDescriptionTasks } from "../../../../../store/slices/DescriptionTask";
import CommaConvert from "../../../../../utils/CommaConvert";
const SalesEfforts = ({ filteredQuotation, projectCostMap, onHtmlGenerated }) => {

    const dispatch = useDispatch();
    const USAComma = CommaConvert();

    const { employees } = useSelector((state) => state.employees);
    useEffect(() => {
        dispatch(fetchEmployees());
    }, [dispatch]);


    // const [taxData, setTaxData] = useState({ perdiem: 0, averagecost: 0 });
    const [perdiem, setperdiem] = useState(0);
    const [averagecost, setaveragecost] = useState(0);

    const { items: otherExpenses } = useSelector((state) => state.otherExpenses);

    const { tasks } = useSelector((state) => state.descriptionTasks);

    useEffect(() => {
        dispatch(fetchSalesTaxes());
        dispatch(fetchQuotations());
        dispatch(fetchOtherExpenses());
    }, [dispatch]);

    useEffect(() => {
        if (otherExpenses && otherExpenses.length > 0 && otherExpenses[0]) {
            const tax = otherExpenses[0];
            setperdiem(tax.perdiem || 0);
            setaveragecost(tax.averagecost || 0);
        } else {
            setperdiem(0);
            setaveragecost(0);
        }
    }, [otherExpenses]);

    useEffect(() => {
        dispatch(fetchDescriptionTasks());
    }, [dispatch]);

    const [groupedTasks, setGroupedTasks] = useState({});

    useEffect(() => {
        if (!tasks || tasks.length === 0 || !filteredQuotation) return;

        const validProjectNames = new Set(Object.keys(filteredQuotation));

        // 🔁 Step 2: Group tasks by projectname, then by createdBy
        const grouped = tasks.reduce((acc, task) => {
            const project = task.projectname;
            const creator = task.createdBy;

            if (validProjectNames.has(project)) {
                if (!acc[project]) {
                    acc[project] = {};
                }

                if (!acc[project][creator]) {
                    acc[project][creator] = [];
                }

                acc[project][creator].push(task);
            }

            return acc;
        }, {});

        setGroupedTasks(grouped);
    }, [tasks, filteredQuotation]);

    const [singleExpenses, setSingleExpenses] = useState([]);

    const [filteredData, setFilteredData] = useState([]);

    /* 3️⃣  Filter whenever either employees or transformedData changes */
    useEffect(() => {
        if (!employees?.length) return; // guard if employees not loaded yet
        const result = filteredData.filter((item) => {
            const emp = employees.find((e) => e._id === item.creatorId);
            return !emp?.customRoles?.includes("project manager");
        });

        setSingleExpenses(result);
    }, [filteredData, employees]);

    useEffect(() => {
        if (!groupedTasks) return;

        const transformedData = [];
        const lowestValues = {
            airfare: Infinity,
            carfuel: Infinity,
            carrental: Infinity,
            lodging: Infinity,
            miscellaneous: Infinity,
            tripdays: Infinity,
        };

        Object.entries(groupedTasks).forEach(([projectName, creatorsMap]) => {
            Object.entries(creatorsMap).forEach(([creatorId, tasks]) => {
                const expense = {
                    projectname: projectName,
                    creatorId: creatorId,
                    lodging: 0,
                    carfuel: 0,
                    airfare: 0,
                    carrental: 0,
                    miscellaneous: 0,
                    tripdays: 0,
                    noofpeople: 1,
                    perdiem: perdiem || 0,
                    averagecost: averagecost || 0,
                };

                tasks.forEach((task) => {
                    switch (task.description) {
                        case "Lodging ($)":
                            expense.lodging = task.value;
                            lowestValues.lodging = Math.min(lowestValues.lodging, task.value);
                            break;
                        case "Car fuel ($)":
                            expense.carfuel = task.value;
                            lowestValues.carfuel = Math.min(lowestValues.carfuel, task.value);
                            break;
                        case "Airfare ($)":
                            expense.airfare = task.value;
                            lowestValues.airfare = Math.min(lowestValues.airfare, task.value);
                            break;
                        case "Car Rental ($)":
                            expense.carrental = task.value;
                            lowestValues.carrental = Math.min(
                                lowestValues.carrental,
                                task.value
                            );
                            break;
                        case "Miscellaneous Install Items to buy ($)":
                            expense.miscellaneous = task.value;
                            lowestValues.miscellaneous = Math.min(
                                lowestValues.miscellaneous,
                                task.value
                            );
                            break;
                        default:
                            console.warn(
                                `Unexpected expense description: ${task.description}`
                            );
                            break;
                    }
                    expense.tripdays = task.tripduration;
                    lowestValues.tripdays = Math.min(
                        lowestValues.tripdays,
                        task.tripduration
                    );
                });

                transformedData.push(expense);
            });
        });

        setFilteredData(transformedData);

        // // Create new array with lowest values but same structure
        // const lowestExpensesData = transformedData.map((expense) => ({
        //   ...expense,
        //   airfare: lowestValues.airfare,
        //   carfuel: lowestValues.carfuel,
        //   carrental: lowestValues.carrental,
        //   lodging: lowestValues.lodging,
        //   miscellaneous: lowestValues.miscellaneous,
        //   tripdays: lowestValues.tripdays,
        //   perdiem: perdiem || 0,
        //   averagecost: averagecost || 0,
        //   // createdBy: lowestValues.createdBy
        // }));

        // setLowestExpenses(lowestExpensesData);
    }, [groupedTasks, perdiem, averagecost]);

    // const [airfare, setAirfare] = useState("");
    // const [carfuel, setCarfuel] = useState("");
    // const [carrental, setCarrental] = useState("");
    // const [lodging, setLodging] = useState("");
    // const [miscellaneous, setMiscellaneous] = useState("");
    // const [tripdays, setTripdays] = useState("");
    // const [totalEmp, setTotalEmp] = useState(0);

    // useEffect(() => {
    //   if (!singleExpenses || singleExpenses.length === 0) return;
    //   setTotalEmp(singleExpenses.length);
    //   const firstExpense = singleExpenses[0];

    //   setAirfare(firstExpense.airfare);
    //   setCarfuel(firstExpense.carfuel);
    //   setCarrental(firstExpense.carrental);
    //   setLodging(firstExpense.lodging);
    //   setMiscellaneous(firstExpense.miscellaneous);
    //   setTripdays(firstExpense.tripdays);
    // }, [singleExpenses]);

    // const miscellaneousTotal = totalEmp * miscellaneous;
    // const airfareTotal = totalEmp * tripdays * airfare;
    // const carrentalTotal = totalEmp * tripdays * carrental;
    // const carfuelTotal = totalEmp * tripdays * carfuel;
    // const lodgingTotal = totalEmp * tripdays * lodging;
    // const perdiemTotal = totalEmp * tripdays * perdiem;
    // const averagecostTotal = totalEmp * tripdays * averagecost;
    // const associateInstallation =
    //   airfareTotal +
    //   miscellaneousTotal +
    //   carrentalTotal +
    //   carfuelTotal +
    //   lodgingTotal +
    //   perdiemTotal +
    //   averagecostTotal;

    // const assoInstaTotal =
    //   airfareTotal +
    //   miscellaneousTotal +
    //   carrentalTotal +
    //   carfuelTotal +
    //   lodgingTotal;

    const {
        peopleTotal,
        tripdaysTotal,
        miscellaneousTotal,
        airfareTotal,
        carrentalTotal,
        carfuelTotal,
        lodgingTotal,
        perdiemTotal,
        averagecostTotal,
        grandTotal, // <- associateInstallation
    } = useMemo(() => {
        const sums = {
            peopleTotal: 0,
            tripdaysTotal: 0,
            miscellaneousTotal: 0,
            airfareTotal: 0,
            carrentalTotal: 0,
            carfuelTotal: 0,
            lodgingTotal: 0,
            perdiemTotal: 0,
            averagecostTotal: 0,
        };

        singleExpenses.forEach((exp) => {
            const mult = Number(exp.noofpeople) || 1;
            const days = Number(exp.tripdays) || 0;
            const misc = Number(exp.miscellaneous) || 0;
            const air = Number(exp.airfare) || 0;
            const rent = Number(exp.carrental) || 0;
            const fuel = Number(exp.carfuel) || 0;
            const lodge = Number(exp.lodging) || 0;
            const diem = Number(exp.perdiem) || 0;
            const avg = Number(exp.averagecost) || 0;

            sums.peopleTotal += mult;
            sums.tripdaysTotal += days; // often shown, even if not summed
            sums.miscellaneousTotal += misc * mult;
            sums.airfareTotal += air * days * mult;
            sums.carrentalTotal += rent * days * mult;
            sums.carfuelTotal += fuel * days * mult;
            sums.lodgingTotal += lodge * days * mult;
            sums.perdiemTotal += diem * days * mult;
            sums.averagecostTotal += avg * days * mult;
        });

        return {
            ...sums,
            grandTotal: Object.values(sums)
                .slice(2) // skip peopleTotal & tripdaysTotal
                .reduce((a, b) => a + b, 0),
        };
    }, [singleExpenses]);

    const AssoInstaPiechart = useMemo(
        () => ({
            "Miscellaneous Install Items to buy ($)": miscellaneousTotal,
            "Airfare ($)": airfareTotal,
            "Car fuel ($)": carfuelTotal, // make sure you’re mapping the right totals
            "Car Rental ($)": carrentalTotal,
            "Lodging ($)": lodgingTotal,
            Total: grandTotal,
        }),
        [
            miscellaneousTotal,
            airfareTotal,
            carfuelTotal,
            carrentalTotal,
            lodgingTotal,
            grandTotal,
        ]
    );

    useEffect(() => {
        dispatch(setAssociateInstallation(grandTotal));
    }, [grandTotal, dispatch]);

    useEffect(() => {
        dispatch(setAssoInstaPiechart(AssoInstaPiechart));
    }, [dispatch, AssoInstaPiechart]);


    const htmlString = `
      <div>
        
    
        <table border="1" style="border-collapse: collapse; width: 100%; font-size: 12px; text-align: center; background-color: #e7ebfb;">
          <thead style="background-color: #1973eb; color: white;">
            <tr>
              <th style="border: 1px solid black;">Description</th>
              <th style="border: 1px solid black;"># of People</th>
              <th style="border: 1px solid black;">Trip Days</th>
              <th style="border: 1px solid black;">Miscellaneous Install Items to buy ($)</th>
              <th style="border: 1px solid black;">Airfare ($)</th>
              <th style="border: 1px solid black;">Car Rental ($)</th>
              <th style="border: 1px solid black;">Car fuel ($)</th>
              <th style="border: 1px solid black;">Lodging ($)</th>
              <th style="border: 1px solid black;">PerDiem</th>
              <th style="border: 1px solid black;">Avg. cost /day</th>
              <th style="border: 1px solid black;">Total</th>
            </tr>
          </thead>
          <tbody>
            ${singleExpenses
            .map(
                (insta) => `
                <tr>
                  <td style="border: 1px solid black;">Operation Person</td>
                  <td style="border: 1px solid black;">${insta.noofpeople}</td>
                  <td style="border: 1px solid black;">${insta.tripdays}</td>
                  <td style="border: 1px solid black;">${insta.miscellaneous}</td>
                  <td style="border: 1px solid black;">${insta.airfare}</td>
                  <td style="border: 1px solid black;">${insta.carrental}</td>
                  <td style="border: 1px solid black;">${insta.carfuel}</td>
                  <td style="border: 1px solid black;">${insta.lodging}</td>
                  <td style="border: 1px solid black;">${insta.perdiem}</td>
                  <td style="border: 1px solid black;">${insta.averagecost}</td>
                  <td style="border: 1px solid black;"></td>
                </tr>
              `
            )
            .join("")}
            <tr>
              <td style="border: 1px solid black;"><strong>Total</strong></td>
              <td style="border: 1px solid black;">${peopleTotal}</td>
              <td style="border: 1px solid black;">${tripdaysTotal}</td>
              <td style="border: 1px solid black;">$${USAComma(miscellaneousTotal)}</td>
              <td style="border: 1px solid black;">$${USAComma(airfareTotal)}</td>
              <td style="border: 1px solid black;">$${USAComma(carrentalTotal)}</td>
              <td style="border: 1px solid black;">$${USAComma(carfuelTotal)}</td>
              <td style="border: 1px solid black;">$${USAComma(lodgingTotal)}</td>
              <td style="border: 1px solid black;">$${USAComma(perdiemTotal)}</td>
              <td style="border: 1px solid black;">$${USAComma(averagecostTotal)}</td>
              <td style="border: 1px solid black;"><strong>$${USAComma(grandTotal)}</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
    `;

    useEffect(() => {
        if (onHtmlGenerated) {
            onHtmlGenerated(htmlString);
        }
    }, [singleExpenses, htmlString, onHtmlGenerated]);
    return (
        <div className="bg-white pt-2 ">
            <div className="text-lg font-semibold pb-2">
                <h2>Salesperson Finance - Associated Installation Cost</h2>
            </div>

            <div>
                <div className="flex w-full bg-[#1973eb] text-center border border-white text-white">
                    <div className="w-[10%] border border-white p-2">Description</div>
                    <div className="w-[10%] border border-white p-2"># of People</div>
                    <div className="w-[10%] border border-white p-2">Trip Days</div>
                    <div className="w-[10%] border border-white p-2">
                        Miscellaneous Install Items to buy ($)
                    </div>
                    <div className="w-[10%] border border-white p-2">Airfare ($)</div>
                    <div className="w-[10%] border border-white p-2">Car Rental ($)</div>
                    <div className="w-[10%] border border-white p-2">Car fuel ($)</div>
                    <div className="w-[10%] border border-white p-2">Lodging ($)</div>
                    <div className="w-[10%] border border-white p-2">PerDiem</div>
                    <div className="w-[10%] border border-white p-2 overflow-hidden text-ellipsis line-clamp-2 break-all break-words leading-snug  text-center">
                        Avg. cost /day
                    </div>
                    <div className="w-[10%] border border-white p-2">Total</div>
                </div>
                {singleExpenses.map((insta, index) => (
                    <div className="flex w-full bg-[#e7ebfb] text-center border border-white text-black">
                        <div className="w-[9.1%] border border-white p-2 overflow-hidden text-ellipsis line-clamp-2 break-all break-words leading-snug  text-center">
                            {`Operation Person`}
                        </div>
                        <div className="w-[9.1%] border border-white p-2">
                            {insta.noofpeople}
                        </div>
                        <div className="w-[9.1%] border border-white p-2">
                            {insta.tripdays}
                        </div>
                        <div className="w-[9.1%] border border-white p-2">
                            {insta.miscellaneous}
                        </div>
                        <div className="w-[9.1%] border border-white p-2">
                            {insta.airfare}
                        </div>
                        <div className="w-[9.1%] border border-white p-2">
                            {insta.carrental}
                        </div>
                        <div className="w-[9.1%] border border-white p-2">
                            {insta.carfuel}
                        </div>
                        <div className="w-[9.1%] border border-white p-2">
                            {insta.lodging}
                        </div>
                        <div className="w-[9.1%] border border-white p-2">
                            {insta.perdiem}
                        </div>
                        <div className="w-[9.1%] border border-white p-2">
                            {insta.averagecost}
                        </div>
                        <div className="w-[9.1%] border border-white p-2"></div>
                    </div>
                ))}
                <div className="flex w-full bg-[#e7ebfb] text-center border border-white text-black ">
                    <div className="w-[9.1%] border border-white p-2">Total</div>
                    <div className="w-[9.1%] border border-white p-2">{peopleTotal}</div>
                    <div className="w-[9.1%] border border-white p-2">
                        {tripdaysTotal}
                    </div>
                    <div className="w-[9.1%] border border-white p-2">
                        ${USAComma(miscellaneousTotal)}
                    </div>
                    <div className="w-[9.1%] border border-white p-2">
                        ${USAComma(airfareTotal)}
                    </div>
                    <div className="w-[9.1%] border border-white p-2">
                        ${USAComma(carrentalTotal)}
                    </div>
                    <div className="w-[9.1%] border border-white p-2">
                        ${USAComma(carfuelTotal)}
                    </div>
                    <div className="w-[9.1%] border border-white p-2">
                        ${USAComma(lodgingTotal)}
                    </div>
                    <div className="w-[9.1%] border border-white p-2">
                        ${USAComma(perdiemTotal)}
                    </div>
                    <div className="w-[9.1%] border border-white p-2">
                        ${USAComma(averagecostTotal)}
                    </div>
                    <div className="w-[9.1%] border border-white p-2">
                        ${USAComma(grandTotal)}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SalesEfforts